import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { useNetDueCalculation } from '../../hooks';

const EntryCodeValue: InputWithSource = ({ input }) => {
    const { triggerNetDueCalculation } = useNetDueCalculation(input);

    const formattedOptions = React.useMemo(
        () =>
            input.sourceProvider.options.map(option => {
                const formattedLabel = `${option.value} – ${option.label}`;
                return {
                    title: formattedLabel,
                    label: formattedLabel,
                    value: option.value
                };
            }),
        [input.sourceProvider.options]
    );

    return (
        <GenericSelect
            onChange={triggerNetDueCalculation}
            label={input.name}
            input={input}
            options={formattedOptions}
        />
    );
};

EntryCodeValue.meta = {
    inputType: InputModelWithSource.name
};

export default observer(EntryCodeValue);
